import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import './BodyHeader.less';
import Cart from '../Cart/Cart';
import {isXOFlow, getViewName} from '../../framework/App/AppUtils';
import Icon, { ICON_TYPE } from '../Icon/Icon';
import {FLOW_TYPE, COUNTRY} from '../../framework/App/AppConstants';
import {PAGE_NAME} from '../../US/config/pageNames';

export class BodyHeader extends Component {
    static propTypes = {
        cartAmount: PropTypes.string,
        flow: PropTypes.string,
        userLoggedIn: PropTypes.bool,
        country: PropTypes.string,
        isMemberFlow: PropTypes.bool,

        // Passed in props
        displayLogout: PropTypes.bool,
        logoutMessage: PropTypes.string,
        paypalLogo: PropTypes.bool
    };

    static defaultProps = {
        displayLogout: false,
        paypalLogo: false
    };

    bodyHeaderIcon() {
        const { country, flow, isMemberFlow } = this.props;

        let icon = ICON_TYPE.PAYPAL_CREDIT_LOGO;

        if (country === COUNTRY.GERMANY
            && flow === FLOW_TYPE.HERMES
            && isMemberFlow) {
            icon = ICON_TYPE.PAYPAL_RATENZAHLUNG;
        }

        if (getViewName() === PAGE_NAME.NEWCUST_PAGE) {
            icon = ICON_TYPE.PAYPAL_LOGO;
        }

        return icon;
    }

    render() {
        const { displayLogout, flow, logoutMessage, userLoggedIn, cartAmount } = this.props;
        const isPurchase = (cartAmount && cartAmount !== '0');

        return (
            <div className="BodyHeader">
                <div className="BodyHeader-row">
                    <div className="BodyHeader-left">
                        <Icon type={this.bodyHeaderIcon()} />
                    </div>
                    <div className="BodyHeader-right">
                        {(isXOFlow(flow) && isPurchase) && <Cart />}
                        {displayLogout && userLoggedIn && (
                            <a id="logout" href="/ppcreditapply/logout">
                                {logoutMessage}
                            </a>
                        )}
                    </div>
                </div>
                <hr className="BodyHeader-hr vx_hr" />
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    cartAmount: _.get(state, 'serverData.cart.subtotal'),
    userLoggedIn: state.serverData.userLoggedIn,
    flow: _.get(state, 'serverData.flow'),
    country: _.get(state, 'serverData.country'),
    isMemberFlow: _.get(state, 'serverData.isMemberFlow')
});

export default connect(mapStateToProps)(BodyHeader);
